import React from "react";
import classnames from "classnames";
import { isLightColor } from "../../legacy/helpers/get-color-brightness";
import ToolTip from "../tool-tip";

class ColorPalette extends React.Component {
    addColorBorder(color) {
        if (!color) {
            return;
        }
        if (color.hex) {
            color = color.hex;
        }
        // Check if color needs border

        if (isLightColor(color)) {
            return "light-color";
        } else {
            return "";
        }
    }

    colorSwatchSelected = color => {
        if (this.props.setColor) {
            this.props.setColor(color);
        }
    };

    render() {
        let colorSwatches = [];

        let presets = this.props.presets || [];
        let presetLength = presets.length;
        let paletteLength = this.props.palette && this.props.palette.length;
        presets.concat(this.props.palette).forEach((color, i) => {
            let colorKey = `color-${i}`;
            let isDefault = i < presetLength;
            let userColorClass = `user-color-${paletteLength +
                presetLength -
                i}`;
            let className = classnames(
                "color",
                colorKey,
                this.addColorBorder(color),
                {
                    "default-color": isDefault,
                    [userColorClass]: !isDefault
                }
            );
            colorSwatches.push(
                <ColorSwatch
                    color={color}
                    key={colorKey}
                    onClick={this.colorSwatchSelected.bind(this, `${color}`)}
                    className={className}
                />
            );
        });

        if (this.props.children) {
            colorSwatches.push(this.props.children);
        }
        return <div className="user-colors">{colorSwatches}</div>;
    }
}

const ColorSwatch = props => {
    let { color, onClick, className } = props;

    if (!color && !props.children) {
        return null;
    }

    let text = props.children || color.toUpperCase();
    let target = props.target || (
        <div
            className={className}
            style={{ backgroundColor: `${color}` }}
            onClick={onClick}
        />
    );
    return (
        <ToolTip
            interactive={false}
            distance={10}
            target={target}
            theme="dark editor"
            delay={600}
        >
            {text}
        </ToolTip>
    );
};

export default ColorPalette;

const presetPalette = [
    "#FF6868",
    "#FFB468",
    "#FFF668",
    "#9AFF68",
    "#66D6FF",
    "#68B4FF",
    "#C868FF",
    "#FF68D7",
    "#A2A2A2",
    "#B3B3B3",

    "#FF3434",
    "#FF9C34",
    "#FFF434",
    "#78FF34",
    "#34C8FF",
    "#349AFF",
    "#B634FF",
    "#FF34C9",
    "#848484",
    "#C3C3C3",

    "#FF0000",
    "#FF8400",
    "#FFF200",
    "#56FF00",
    "#02BAFF",
    "#0080FF",
    "#A400FF",
    "#FF00BB",
    "#666666",
    "#D3D3D3",

    "#E60000",
    "#E67700",
    "#E6DA00",
    "#4CE600",
    "#02A9E6",
    "#0073E6",
    "#9500E6",
    "#E600A8",
    "#4D4D4D",
    "#E3E3E3",

    "#CC0000",
    "#CC6900",
    "#CCC200",
    "#44CC00",
    "#0296CC",
    "#0066CC",
    "#8500CC",
    "#CC0096",
    "#333333",
    "#F3F3F3",

    "#B30000",
    "#B35C00",
    "#B3AA00",
    "#3BB300",
    "#0283B3",
    "#0059B3",
    "#7400B3",
    "#B30083",
    "#1A1A1A",
    "#FFFFFF"
];

export const PresetPalette = props => {
    return (
        <div className="editor-preset-palette">
            {presetPalette.map((hex, i) => {
                let className = "editor-color-swatch";
                return (
                    <ColorSwatch
                        color={hex}
                        key={i}
                        className={className}
                        onClick={props.setColor.bind(null, `${hex}`)}
                    />
                );
            })}
        </div>
    );
};
